import pegasus from "../../assets/scripts/global/01-pegasus";
class PostFilter {
        currentFilters = {}
        pendingFilters = {}
        catDropdownOpen = false
        dropdownOpen = null
        modalOpen = null
        showResetBtn = false
        searchTerm = ""
        showMainScrollIndicator = false
        filterPrefix = {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            post_type: "filter-pt-",
            search: ""
        }

        isSticking = false
        isOpen = false
        searchIsOpen = false
        stickyPositioning = 'none'
        constructor(stickyPositioning, prefilteredCategory = null) {
            this.stickyPositioning = stickyPositioning || 'none';
            this.prefilteredCategory = prefilteredCategory;
            this._mainListTotalWidth = null;
            this._mainResizeObserver = null;
            this._wrapperResizeObserver = null;
        }
        init() {
            switch (this.stickyPositioning) {
                case 'container':
                    this.$el.classList.add('sticky');
                    break;
                case 'body':
                    this.initFixedSticky();
                    break;
            }

            this.currentFilters = this.getCurrentFilters();
            // Initialize pendingFilters with current filters (for dropdown variant)
            this.pendingFilters = { ...this.currentFilters };

            // If no filters from URL and a prefiltered category is set
            if (!Object.keys(this.currentFilters).length && this.prefilteredCategory) {
                this.currentFilters[`filter-t-people-types`] = this.prefilteredCategory;

                // Immediately dispatch filter event to update post grid
                this.$nextTick(() => {
                    this.$dispatch("pegasus-post-filter-toggle", {
                        currentFilters: this.currentFilters,
                        fromPrefilter: true
                    });
                });

                this.showResetBtn = true;
            }
        
            if (this.currentFilters["filter-search"]) {
              this.searchTerm = this.currentFilters["filter-search"];
            }
        
            if (Object.keys(this.currentFilters).length) {
              this.showResetBtn = true;
            }
            
            // Watch for changes to currentFilters to update UI
            this.$watch("currentFilters", () => {
              // This will trigger Alpine to re-evaluate any expressions related to currentFilters
              // Ensuring our dropdown labels update
            });
        }  
        handleSearch() {
            this.currentFilters["filter-search"] = this.searchTerm;
            if (!this.searchTerm) {
                delete this.currentFilters["filter-search"];
            }
            this.$dispatch("pegasus-post-filter-toggle", {
                currentFilters: this.currentFilters,
            });
            this.showResetBtn = Object.keys(this.currentFilters).length > 0;
        } 
        selectFilter(term, filterName, type = "taxonomy") {
            const hasCombinedFiltersEl = this.$el.closest("[data-combine-filters]");
            if (hasCombinedFiltersEl && hasCombinedFiltersEl.dataset.combineFilters == "1") {
                this.toggleFilters(term, filterName, type, true);
            } else {
                this.toggleFilters(term, filterName, type, false);
            }

            this.$dispatch("pegasus-post-filter-toggle", {
                currentFilters: this.currentFilters,
            });
            
            this.showResetBtn = true;
            this.catDropdownOpen = false;
            this.dropdownOpen = null;
        }
        selectFilterPending(term, filterName, type = "taxonomy", event = null) {
            // For dropdown variant
            const dropdownContainer = this.$el.querySelector(`[data-dropdown-index]`);
            const hasCombinedFiltersEl = dropdownContainer ? dropdownContainer.closest("[data-combine-filters]") : null;
            const combine = hasCombinedFiltersEl && hasCombinedFiltersEl.dataset.combineFilters == "1";
            
            const filter = this.getPrefixedFilter(filterName, type);
            
            if (!combine) {
                if (type === 'meta') {
                    const filterPrefix = this.filterPrefix[type];
                    Object.keys(this.pendingFilters).forEach((key) => {
                        if (key === filterPrefix + filterName) {
                            delete this.pendingFilters[key];
                        }
                    });
                } else {
                    // For other types, clear only the exact filter match
                    Object.keys(this.pendingFilters).forEach((key) => {
                        if (key === filter) {
                            delete this.pendingFilters[key];
                        }
                    });
                }
                
                // Set the new filter
                this.pendingFilters[filter] = term;
            } else {
                // Combine filters logic
                if (typeof this.pendingFilters[filter] === "undefined") {
                    this.pendingFilters[filter] = term;
                } else if (this.pendingFilters[filter].length) {
                    if (this.pendingFilters[filter].includes(term)) {
                        this.pendingFilters[filter] = this.removeFilterPending(filter, term);
                        if (!this.pendingFilters[filter].length) {
                            delete this.pendingFilters[filter];
                        }
                    } else {
                        this.pendingFilters[filter] += "," + term;
                    }
                } else {
                    this.pendingFilters[filter] = term;
                }
            }
            
            // Close the dropdown after selection
            if (event && event.target) {
                const clickedElement = event.target.closest('button') || event.target;
                if (clickedElement) {
                    const dropdownContainer = clickedElement.closest('[data-dropdown-index]');
                    if (dropdownContainer && dropdownContainer.dataset.dropdownIndex) {
                        const dropdownIndex = parseInt(dropdownContainer.dataset.dropdownIndex);
                        if (this.dropdownOpen === dropdownIndex) {
                            this.dropdownOpen = null;
                        }
                    }
                }
            }
        }
        removeFilterPending(filter, value) {
            const filterValue = this.pendingFilters[filter];
            const filterValueArray = filterValue.split(",");
            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }
            return filterValueArray.toString();
        }
        clearPendingFiltersForDropdown(filterPrefix) {
            // Clear pending filters that match the given prefix
            Object.keys(this.pendingFilters).forEach(key => {
                if (key.startsWith(filterPrefix)) {
                    delete this.pendingFilters[key];
                }
            });
        }
        submitFilters() {
            // Apply pendingFilters to currentFilters and dispatch
            this.currentFilters = { ...this.pendingFilters };
            
            // Handle search term if it exists
            if (this.searchTerm) {
                this.currentFilters["filter-search"] = this.searchTerm;
            } else {
                delete this.currentFilters["filter-search"];
            }
            
            // Build URL with filter parameters
            const url = new URL(window.location.href);
            url.search = '';
            
            // Add all current filters to URL
            Object.keys(this.currentFilters).forEach(key => {
                if (this.currentFilters[key]) {
                    url.searchParams.set(key, this.currentFilters[key]);
                }
            });
            
            // Update URL and dispatch event
            window.history.pushState({}, '', url);
            
            this.$dispatch("pegasus-post-filter-toggle", {
                currentFilters: this.currentFilters,
            });
            
            this.showResetBtn = Object.keys(this.currentFilters).length > 0;
            
            // Close all dropdowns
            this.dropdownOpen = null;
        }
        handleDropdownClickAway(event, currentIndex) {
            // Check if click is on any dropdown button
            const clickedButton = event.target.closest('[data-dropdown-button]');
            if (clickedButton) {
                return;
            }
            
            const clickedInDropdown = event.target.closest('.relative[data-dropdown-index]');
            if (clickedInDropdown) {
                return;
            }
            
            if (this.dropdownOpen === currentIndex) {
                this.dropdownOpen = null;
            }
        }
        openModal(index) {
            this.modalOpen = index;
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }
        closeModal() {
            this.modalOpen = null;
            // Restore body scroll
            document.body.style.overflow = '';
            // Apply the pending filters when modal closes
            this.submitFilters();
        }
        toggleFilters(term = "", filterName = "", type = "taxonomy", combine = true) {
            const filter = this.getPrefixedFilter(filterName, type);
            
            if (!combine) {
                // Clear any filters of the same type before adding the new one
                const filterPrefix = this.filterPrefix[type];
                Object.keys(this.currentFilters).forEach((key) => {
                    if (key.startsWith(filterPrefix)) {
                        delete this.currentFilters[key];
                    }
                });
                
                // Set the new filter
                this.currentFilters[filter] = term;
                return;
            }
            
            // Combine filters logic (original behavior)
            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;
                return;
            }
            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    this.currentFilters[filter] = this.removeFilter(filter, term);
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                this.currentFilters[filter] = term;
            }
        }
        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");
            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }
            return filterValueArray.toString();
        }
        clearFilters() {
            this.currentFilters = {};
            this.pendingFilters = {};
            this.searchTerm = "";
            this.catDropdownOpen = false;
            
            const currentUrl = pegasus.getURL();
            const data = {
                action: 'pegasus_post_filter',
                filters: JSON.stringify({}),
                nonce: pegasus.nonce
            };
            
            pegasus.ajaxContent(currentUrl, ['[data-post-filter]'], data, () => {
                this.$dispatch("pegasus-post-filter-toggle", { currentFilters: {} });
                this.showResetBtn = false;
                
                const url = new URL(window.location.href);
                url.search = '';
                window.history.pushState({}, '', url);
            });
        }
        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        }

        getCurrentFilters() {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            let currentFilters = {};
            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }
            return currentFilters;
        }
        filterIsActive(term, filter, type = "taxonomy", usePending = false) {
            const filterName = this.getPrefixedFilter(filter, type);
            const filtersToCheck = usePending ? this.pendingFilters : this.currentFilters;

            if (typeof filtersToCheck[filterName] !== "undefined") {
                const values = filtersToCheck[filterName].split(',');
                return values.includes(term);
            }
            return false;
        }
        
        // Convert string to title case (capitalize first letter of each word)
        toTitleCase(str) {
            return str.replace(/\w\S*/g, (txt) => {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
        
        hasActiveFilterForDropdown(filterPrefix, usePending = false) {
            const filtersToCheck = usePending ? this.pendingFilters : this.currentFilters;
            return Object.keys(filtersToCheck).some(key => key.startsWith(filterPrefix));
        }
        
        get getDropdownLabel() {
            return (defaultLabel, dropdownType, taxonomyName = null, usePending = false) => {
                if (!dropdownType || dropdownType === 'none' || dropdownType === 'links') {
                    return defaultLabel;
                }
                
                const prefix = dropdownType === 'taxonomies' ? this.filterPrefix.taxonomy : 
                               dropdownType === 'post_types' ? this.filterPrefix.post_type : '';
                
                // Use pendingFilters for dropdown variant, currentFilters for classic variant
                const filtersToCheck = usePending ? this.pendingFilters : this.currentFilters;
                
                // Check if any filter with this prefix exists
                let selectedFilter = null;
                Object.keys(filtersToCheck).forEach(key => {
                    if (key.startsWith(prefix)) {
                        // If taxonomyName is provided, only check filters for that specific taxonomy
                        if (taxonomyName && dropdownType === 'taxonomies') {
                            // Filter key format: filter-t-{taxonomy_name}
                            const expectedKey = `${this.filterPrefix.taxonomy}${taxonomyName}`;
                            if (key === expectedKey) {
                                selectedFilter = {
                                    key,
                                    value: filtersToCheck[key]
                                };
                            }
                        } else {
                            // If no taxonomy name specified, use first matching filter (backward compatibility)
                            if (!selectedFilter) {
                                selectedFilter = {
                                    key,
                                    value: filtersToCheck[key]
                                };
                            }
                        }
                    }
                });
                
                // If no filter is selected, return default label
                if (!selectedFilter) {
                    return defaultLabel;
                }
                
                // Extract the filter name from the key
                const filterValue = selectedFilter ? selectedFilter.value : null;
                
                if (!filterValue) {
                    return defaultLabel;
                }
                
                // For post types, try to find the display name from the label/button in the DOM
                if (dropdownType === 'post_types') {
                    // Try to find a label/button with the matching post type name to get its display name
                    const postTypeElements = document.querySelectorAll('label[data-post-type], button[data-post-type]');
                    for (const element of postTypeElements) {
                        if (element.dataset.postType === filterValue) {
                            return element.querySelector('span').textContent.trim(); // Return the human-readable name
                        }
                    }
                }

                
                if (dropdownType === 'taxonomies') {
                    // Find label/button within the same dropdown container to get the correct display name
                    const dropdownContainer = this.$el.querySelector(`[data-dropdown-index]`);
                    if (dropdownContainer) {
                        const taxElements = dropdownContainer.querySelectorAll('label[data-tax-slug], button[data-tax-slug]');
                        for (const element of taxElements) {
                            if (element.dataset.taxSlug === filterValue) {
                                return element.querySelector('span').textContent.trim(); // Return the human-readable name
                            }
                        }
                    }
                    
                    // Fallback: search all tax labels/buttons
                    const taxElements = document.querySelectorAll('label[data-tax-slug], button[data-tax-slug]');
                    for (const element of taxElements) {
                        if (element.dataset.taxSlug === filterValue) {
                            return element.querySelector('span').textContent.trim(); // Return the human-readable name
                        }
                    }
                }
                
                // Handle multiple selected values
                if (filterValue.includes(',')) {
                    const count = filterValue.split(',').length;
                    return `${count} selected`;
                }
                
                // For single value, return just the value in title case without the default label
                return this.toTitleCase(filterValue);
            };
        }
    }

document.addEventListener("alpine:init", () => {
    Alpine.data("postFilter", (stickyPositioning, prefilteredCategory = null) => new PostFilter(stickyPositioning, prefilteredCategory));
});